import { c as _c } from "react/compiler-runtime";
import { ChevronDownIcon } from '@systemeio/icons';
import { useId, useState } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { MOBILE_NAVBAR_ITEM_CLASS_NAME } from 'shared/components/navbar/constants';
import type { MenuItem } from 'shared/components/navbar/types/menu-item';
import { hasRenderableMenuItem } from 'shared/components/navbar/utils/has-renderable-menu-item';
import { isNestedMenuItemActive } from 'shared/components/navbar/utils/is-menu-item-active';
import { isMenuLink } from 'shared/components/navbar/utils/is-menu-link';
import { twJoin, twMerge } from 'tailwind-merge';
interface MobileMenuItemProps {
  className?: string;
  item: MenuItem;
}
export function MobileMenuItem(t0) {
  const $ = _c(62);
  const {
    className,
    item
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const contentId = useId();
  if (isMenuLink(item)) {
    if (!item.shouldRender) {
      return null;
    }
    let T0;
    let t1;
    let t2;
    if ($[0] !== className || $[1] !== item) {
      const isActive = item.isActive(item.href);
      T0 = LinkWithoutPrefetch;
      t1 = isActive ? "page" : undefined;
      t2 = twMerge(MOBILE_NAVBAR_ITEM_CLASS_NAME, className, isActive && "text-text-link [&_svg]:text-icon-accent");
      $[0] = className;
      $[1] = item;
      $[2] = T0;
      $[3] = t1;
      $[4] = t2;
    } else {
      T0 = $[2];
      t1 = $[3];
      t2 = $[4];
    }
    let t3;
    if ($[5] !== item) {
      t3 = item.mobileIconRenderer?.();
      $[5] = item;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== item.name) {
      t4 = <span className="min-w-0 truncate">{item.name}</span>;
      $[7] = item.name;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== T0 || $[10] !== item.dataTestId || $[11] !== item.href || $[12] !== item.target || $[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
      t5 = <T0 aria-current={t1} className={t2} data-test-id={item.dataTestId} href={item.href} target={item.target}>{t3}{t4}</T0>;
      $[9] = T0;
      $[10] = item.dataTestId;
      $[11] = item.href;
      $[12] = item.target;
      $[13] = t1;
      $[14] = t2;
      $[15] = t3;
      $[16] = t4;
      $[17] = t5;
    } else {
      t5 = $[17];
    }
    return t5;
  }
  if (!hasRenderableMenuItem(item.dropdownItems)) {
    return null;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[18] !== className || $[19] !== contentId || $[20] !== isOpen || $[21] !== item) {
    const isActive_0 = isNestedMenuItemActive(item);
    t4 = "flex min-w-0 flex-col";
    t1 = contentId;
    t2 = isOpen;
    t3 = twMerge("focus-visible:focus-ring-primary outline-none", MOBILE_NAVBAR_ITEM_CLASS_NAME, "active:bg-bg-tertiary", className, isActive_0 && "text-text-link [&_svg]:text-icon-accent");
    $[18] = className;
    $[19] = contentId;
    $[20] = isOpen;
    $[21] = item;
    $[22] = t1;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
  } else {
    t1 = $[22];
    t2 = $[23];
    t3 = $[24];
    t4 = $[25];
  }
  const t5 = `${item.id}-menu-button`;
  let t6;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsOpen(_temp);
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== item) {
    t7 = item.mobileIconRenderer?.();
    $[27] = item;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== item.name) {
    t8 = <span className="min-w-0 truncate">{item.name}</span>;
    $[29] = item.name;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  const t9 = isOpen && "rotate-180";
  let t10;
  if ($[31] !== t9) {
    t10 = twJoin("transition-base", "ml-auto size-5", t9);
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10) {
    t11 = <ChevronDownIcon className={t10} />;
    $[33] = t10;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t1 || $[36] !== t11 || $[37] !== t2 || $[38] !== t3 || $[39] !== t5 || $[40] !== t7 || $[41] !== t8) {
    t12 = <button aria-controls={t1} aria-expanded={t2} className={t3} data-test-id={t5} onClick={t6} type="button">{t7}{t8}{t11}</button>;
    $[35] = t1;
    $[36] = t11;
    $[37] = t2;
    $[38] = t3;
    $[39] = t5;
    $[40] = t7;
    $[41] = t8;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  const t13 = !isOpen;
  const t14 = isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0";
  let t15;
  if ($[43] !== t14) {
    t15 = twJoin("transition-base grid transition-[grid-template-rows,opacity]", t14);
    $[43] = t14;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  const t16 = !isOpen;
  const t17 = isOpen ? "translate-y-0" : "-translate-y-1";
  let t18;
  if ($[45] !== t17) {
    t18 = twJoin("transition-base flex min-w-0 flex-col pl-6 transition-transform", t17);
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== item.dropdownItems) {
    t19 = item.dropdownItems.map(_temp2);
    $[47] = item.dropdownItems;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t18 || $[50] !== t19) {
    t20 = <div className="min-h-0 overflow-hidden"><div className={t18}>{t19}</div></div>;
    $[49] = t18;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== contentId || $[53] !== t13 || $[54] !== t15 || $[55] !== t16 || $[56] !== t20) {
    t21 = <div aria-hidden={t13} className={t15} id={contentId} inert={t16}>{t20}</div>;
    $[52] = contentId;
    $[53] = t13;
    $[54] = t15;
    $[55] = t16;
    $[56] = t20;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== t12 || $[59] !== t21 || $[60] !== t4) {
    t22 = <div className={t4}>{t12}{t21}</div>;
    $[58] = t12;
    $[59] = t21;
    $[60] = t4;
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  return t22;
}
function _temp2(child) {
  return <MobileMenuItem className="text-text-secondary" item={child} key={isMenuLink(child) ? child.href : child.id} />;
}
function _temp(value) {
  return !value;
}